<template>
    <b-row>
      <b-col sm="12" xl="10">
        <template v-if="isAdmin">
          <h4>{{ exchange.name }} Exchange Profile</h4>
          <b-card bg-variant="light" title="Admin Settings" class="my-2">
            <b-row>
              <b-col md="2">
                <b-form-group
                  label="Markup Margin" description="Take rate markup">
                  <b-form-input v-model="exchange.markup" required
                                type="number"/>
                </b-form-group>
              </b-col>
              <!--
              <b-col md="2">
                <b-form-group
                  label="Floor Markup" description="Addtl floor increase">
                  <b-form-input v-model="exchange.floor_markup" required
                                type="number" />
                </b-form-group>
              </b-col>
              -->
              <b-col md="2">
                <b-form-group
                  label="Timeout offset">
                  <b-form-input
                    type="number"
                    v-model="exchange.timeout">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Take Rate Optimization">
                  <toggle-button
                    v-model="exchange.take_rate_optimization"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Malware Scanning">
                  <toggle-button
                    v-model="exchange.tmt"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Optimize Floors">
                  <toggle-button
                    :disabled="!isSuperAdmin"
                    v-model="exchange.optimize_floors"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Advertible">
                  <toggle-button
                    v-model="exchange.advertible"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <b-form-group
                  label="Send BURL">
                  <toggle-button
                    v-model="exchange.auction_burl"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="ADM Beacon">
                  <toggle-button
                    v-model="exchange.auction_win_beacon"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Is Direct Supply">
                  <toggle-button
                    v-model="exchange.direct_supply"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Only Store Bids">
                  <toggle-button
                    v-model="exchange.store_only_bids"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Soft Floors">
                  <toggle-button
                    v-model="exchange.soft_floors"
                    :sync="true"
                    color="#2bd879">
                  </toggle-button>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="X-15 Proxy">
                  <b-form-input
                    :disabled="!isSuperAdmin"
                    type="number"
                    v-model="exchange.x15_proxy_fraction">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-row>
              <b-form-group class="w-100" label="Global hard request pub.id or bundle or domain blacklist"
                            description="Any request with a matching pub.id, bundle, or domain will be blocked. One value per newline.">
                <newline-editor v-model="exchange.req_id_blacklist" />
              </b-form-group>
            </b-form-row>
          </b-card>
        </template>

        <prebid-bidders v-model="exchange" :server-only="true"></prebid-bidders>

        <b-card title="Demand Filters" class="mb-3">
          <b-form-row>
            <b-col md="3">
              <b-form-group label="Clear Adomains" v-if="exchange.blocked_adomains && exchange.blocked_adomains.length">
                <b-btn class="btn-sm mt-1"
                       @click="exchange.blocked_adomains = []">Clear</b-btn>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col md="12">
              <b-form-group label="List of blocked advertiser domains">
                <string-list-editor :values="exchange.blocked_adomains"
                                    placeholder="Enter advertiser domain"></string-list-editor>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col md="3">
              <b-form-group label="Clear IDs" v-if="exchange.blocked_crids && exchange.blocked_crids.length">
                <b-btn class="btn-sm mt-1"
                       @click="exchange.blocked_crids = []">Clear</b-btn>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col md="12">
              <b-form-group label="List of blocked creative IDs">
                <string-list-editor :values="exchange.blocked_crids"
                                    placeholder="Enter advertiser creative ID"></string-list-editor>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-card>

        <b-card class="my-2">
          <h5 class="my-4">Exchange Settings</h5>
          <b-form-row>
            <b-col md="8">
              <b-form-group
                label="Exchange Display Name">
                <b-form-input
                  type="text"
                  v-model="exchange.name">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                :label="exchange.enabled ? 'Enabled' : 'Disabled'">
                <toggle-button
                  v-model="exchange.enabled"
                  :color="{ checked: '#2bd879', unchecked: '#F1516C' }"
                  :sync="true">
                </toggle-button>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col md="4">
              <b-form-group
                label="Restricted">
                <toggle-button
                  v-model="exchange.restricted"
                  :sync="true"
                  color="#2bd879">
                </toggle-button>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Supports Multi Seat">
                <toggle-button
                  v-model="exchange.auction_multi_seat"
                  :sync="true"
                  color="#2bd879">
                </toggle-button>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Supports Multi Bid">
                <toggle-button
                  v-model="exchange.auction_multi_bid"
                  :sync="true"
                  color="#2bd879">
                </toggle-button>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-btn @click="save()" variant="primary" class="mt-4">
            {{ status !== 'new' ? 'Save Changes' : 'Create'}}
          </b-btn>
        </b-card>

        <report-api :cid="cid" mode="exchange" />
      </b-col>
    </b-row>
</template>

<script>
    import {ExchangeApi} from '../api'
    import auth from '@/auth'
    import ReportApi from '../../components/ReportApi'
    import PrebidBidders from '../../publisher/pages/Zone/PrebidBidders.vue'
    import NewlineEditor from "../../components/NewlineEditor.vue";
    import StringListEditor from "../../components/StringListEditor.vue";

    export default {
      components: {StringListEditor, NewlineEditor, ReportApi, PrebidBidders},
      props: {
            cid: {required: false}
        },
        data() {
            return {
                status: 'loading',
                isSuperAdmin: auth.isSuperAdmin(),
                exchange: {
                    company_id: this.companyId(),
                    tmt: false,
                    ad_quality: 'GENERAL',
                    markup: 19,
                    auction_burl: true,
                    floor_markup: 1,
                    timeout: 20,
                    enabled: true,
                    advertible: false,
                    x15_proxy_fraction: 0,
                    restricted: false,
                    auction_win_beacon: false,
                    auction_multi_seat: true,
                    blocked_adomains: [],
                    blocked_crids: [],
                    auction_multi_bid: true,
                    auto_throttle: false,
                    store_only_bids: false,
                    force_bid: false,
                    direct_supply: false,
                    soft_floors: false,
                    req_id_blacklist: [],
                    bidders: [],
                    optimize_floors: false,
                    take_rate_optimization: false
                }
            }
        },
      created() {
        ExchangeApi.details(this.companyId()).then((exchange) => {
          if (exchange) {
            if (!exchange.blocked_crids)
              exchange.blocked_crids = [];
            if (!exchange.blocked_adomains)
              exchange.blocked_adomains = [];
            this.exchange = exchange

            this.status = 'loaded'
          } else {
            this.status = 'new'
          }
        }).catch(() => this.status = 'new')
      },
        methods: {
            save() {
                ExchangeApi.save(this.exchange).then((r) => {
                    if (this.status === 'new') {
                        this.$notify.success('Exchange profile created')
                        auth.exchange(this.exchange)
                        this.status = 'loaded'
                    } else {
                        this.$notify.success('Exchange settings saved')
                    }
                })
            },
            companyId() {
                if (this.cid) {
                    return this.cid
                }
                return auth.details().company_id
            }
        },
        computed: {
            isAdmin() {
                return auth.isAdmin()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/exchange/pages/ExchangeSettings.vue